import servicesConfig, { CustomAxiosHeaders } from '../config/services'

import { AxiosResponse } from 'axios'
import config from './../config/index'
import { requests } from '.'

// Configure request setup
const serviceName = 'LCPhoneService'
const host = config.ghlRevexBackendUrl
const opts: CustomAxiosHeaders = { host, serviceName }
const request = (addlOpts?: CustomAxiosHeaders) => {
  return requests(Object.assign({}, opts, addlOpts))
}

// Helper function to handle response
const responseBody = (res: AxiosResponse) => res.data

// Define service object with methods
const LCPhoneService = {
  listRegulatoryBundles: async (locationId: string) => {
    const { data } = await request().get(`/regulatory-bundles/list?locationId=${locationId}`).then(responseBody)
    return data
  },

  submitAddressInformation: async (data: any) => {
    const response = await request().post('/regulatory-bundles/address', data).then(responseBody)
    return response
  },

  createRegulatoryBundle: async (data: any) => {
    const response = await request().post('/regulatory-bundles', data).then(responseBody)
    return response
  },

  createEndUser: async (data: any) => {
    const response = await request().post('/regulatory-bundles/end-user', data).then(responseBody)
    return response
  },

  listAddresses: async (locationId: string) => {
    const response = await request().get(`/regulatory-bundles/addresses?locationId=${locationId}`).then(responseBody)
    return response
  },

  submitRegulatoryBundle: async (data: any) => {
    const response = await request().post('/regulatory-bundles/submit', data).then(responseBody)
    return response
  },

  attachDocuments: async (locationId: string, data: any) => {
    const response = await request()
      .post(`/regulatory-bundles/attach-documents?locationId=${locationId}`, data)
      .then(responseBody)
    return response
  },

  deleteBundle: async (data: any) => {
    const response = await request()
      .delete(`/regulatory-bundles?locationId=${data.locationId}&bundleSid=${data.bundleSid}`)
      .then(responseBody)
    return response
  },

  deleteAddress: async (data: any) => {
    const response = await request()
      .delete(`/regulatory-bundles/address?locationId=${data.locationId}&addressSid=${data.addressSid}`)
      .then(responseBody)
    return response
  },

  getBundleDetails: async (data: any) => {
    const response = await request()
      .get(`/regulatory-bundles/bundle-details?locationId=${data.locationId}&bundleSid=${data.bundleSid}`)
      .then(responseBody)
    return response
  },

  getRejectionReason: async (data: any) => {
    const response = await request()
      .get(`/regulatory-bundles/rejection-reason?locationId=${data.locationId}&bundleSID=${data.bundleSid}`)
      .then(responseBody)
    return response
  },

  putTwilioData: async (locationId: string, data: any) => {
    const response = await request().put(`/twilio-accounts?locationId=${locationId}`, data).then(responseBody)
    return response
  },
}

export const LcPhoneService = LCPhoneService

export default {}
